import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout, Spin } from 'antd';

// 导入页面组件
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import DashboardLayout from './components/layout/DashboardLayout';
import DashboardPage from './pages/DashboardPage';
import OnboardingPage from './pages/OnboardingPage';
import KycPage from './pages/KycPage';
import OrdersPage from './pages/OrdersPage';
import PaymentsPage from './pages/PaymentsPage';
// 发卡（虚拟卡）功能未上线，暂时隐藏入口；页面组件保留以便将来恢复。
// import CardsPage from './pages/CardsPage';
import SettingsPage from './pages/SettingsPage';
import NotFoundPage from './pages/NotFoundPage';
import BalancePage from './pages/BalancePage';
import RefundsPage from './pages/RefundsPage';
import DisputesPage from './pages/DisputesPage';
import TreasuryPage from './pages/TreasuryPage';
import PaymentLinksPage from './pages/PaymentLinksPage';
import ReportsPage from './pages/ReportsPage';
import NotificationsPage from './pages/NotificationsPage';
import ChannelsPage from './pages/ChannelsPage';
import FeeConfigPage from './pages/FeeConfigPage';

// 商品目录 / 客户 / 收银会话
import ProductsPage from './pages/catalog/ProductsPage';
import CheckoutSessionsPage from './pages/catalog/CheckoutSessionsPage';
import CustomersPage from './pages/customers/CustomersPage';

// 订阅管理
import SubscriptionsPage from './pages/SubscriptionsPage';

// Admin pages
import GroupsPage from './pages/admin/GroupsPage';
import GroupFeeConfigPage from './pages/admin/GroupFeeConfigPage';

// Checkout pages
import CheckoutPage from './pages/checkout/CheckoutPage';
import SuccessPage from './pages/checkout/SuccessPage';
import CancelPage from './pages/checkout/CancelPage';

// 白标加卡页面（公开路由）—— 发卡功能未上线，暂时隐藏（页面保留）
// import AddCardPage from './pages/cards/AddCardPage';

// 导入CSS
import './App.css';

const App: React.FC = () => {
  return (
    <div className="app">
      <Routes>
        {/* 公开路由 */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* 公开收银台路由 */}
        <Route path="/checkout/:id" element={<CheckoutPage />} />
        <Route path="/checkout/success" element={<SuccessPage />} />
        <Route path="/checkout/cancel" element={<CancelPage />} />

        {/* 公开白标加卡路由 —— 发卡功能未上线，暂时隐藏（页面保留） */}
        {/* <Route path="/cards/add" element={<AddCardPage />} /> */}

        {/* 受保护的路由 */}
        <Route path="/" element={<DashboardLayout />}>
          {/* 仪表盘 */}
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />

          {/* 入驻管理 */}
          <Route path="onboarding" element={<OnboardingPage />} />

          {/* 实名认证 (KYC) */}
          <Route path="kyc" element={<KycPage />} />

          {/* 订单管理 */}
          <Route path="orders" element={<OrdersPage />} />

          {/* 支付管理 */}
          <Route path="payments" element={<PaymentsPage />} />

          {/* 虚拟卡管理 —— 发卡功能未上线，暂时隐藏（页面保留） */}
          {/* <Route path="cards" element={<CardsPage />} /> */}

          {/* 财务管理 */}
          <Route path="balance" element={<BalancePage />} />
          <Route path="treasury" element={<TreasuryPage />} />

          {/* 商品目录 / 客户 / 收银会话 */}
          <Route path="catalog/products" element={<ProductsPage />} />
          <Route path="customers" element={<CustomersPage />} />
          <Route path="checkout-sessions" element={<CheckoutSessionsPage />} />

          {/* 订阅管理 */}
          <Route path="subscriptions" element={<SubscriptionsPage />} />

          {/* 交易管理 */}
          <Route path="payment-links" element={<PaymentLinksPage />} />
          <Route path="refunds" element={<RefundsPage />} />
          <Route path="disputes" element={<DisputesPage />} />

          {/* 报表和系统 */}
          <Route path="reports" element={<ReportsPage />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="channels" element={<ChannelsPage />} />

          {/* 费率配置 */}
          <Route path="fee-config" element={<FeeConfigPage />} />

          {/* 管理员路由 */}
          <Route path="admin/groups" element={<GroupsPage />} />
          <Route path="admin/groups/:groupId/fee-config" element={<GroupFeeConfigPage />} />

          {/* 设置 */}
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        {/* 404页面 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </div>
  );
};

export default App; 